import { render, staticRenderFns } from "./Kickback.vue?vue&type=template&id=c4368cd6&"
import script from "./Kickback.vue?vue&type=script&lang=js&"
export * from "./Kickback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports